<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">
    <v-card outlined tile>
      <v-card-text>
        <v-row align="baseline">
          <v-col cols="2" align="right">
            <div class="subtitle-2">{{ $authUser.name }}</div>
          </v-col>

          <v-col cols="10">
            <v-text-field
              hide-details="true"
              label="Add comment"
              dense
              outlined
              v-model="formData.body"
              :rules="[$formRules.required]"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col offset="2" cols="10">
            <file-upload-input />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" align="end">
            <v-btn
              tile
              color="secondary"
              depressed
              :disabled="!valid"
              :loading="loading"
              type="submit"
            >
              Send
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import FileUploadInput from '@/components/common/FileUploadInput'

export default {
  name: 'DiscussionCreateEditForm',
  props: {
    discussableId: {
      type: Number,
      required: true
    },
    storeModuleName: {
      type: String,
      required: true
    },
    discussion: {
      type: Object,
      required: false
    }
  },
  components: {
    FileUploadInput
  },
  data: () => ({
    valid: false,
    loading: false,
    formData: {
      body: ''
    }
  }),
  methods: {
    storeDiscussion(payload) {
      return this.$store.dispatch(
        `${this.storeModuleName}/storeDiscussion`,
        payload
      )
    },
    updateDiscussion(payload) {
      return this.$store.dispatch(
        `${this.storeModuleName}/updateDiscussion`,
        payload
      )
    },
    setFormDefaults() {
      this.formData = {
        body: this.discussion ? this.discussion.body : ''
      }
    },
    submit() {
      this.loading = true

      if (this.taskList && this.taskList.id) {
        this.updateDiscussion({
          discussable_id: this.discussableId,
          id: this.discussion.id,
          ...this.formData
        }).then(() => {
          this.loading = false

          this.cancel()
        })
      } else {
        this.storeDiscussion({
          discussable_id: this.discussableId,
          ...this.formData
        }).then(() => {
          this.loading = false

          this.cancel()
        })
      }
    },
    cancel() {
      this.$refs.form.reset()

      this.$nextTick(() => {
        this.setFormDefaults()
      })

      this.$emit('cancel')
    }
  },
  created() {
    this.setFormDefaults()
  }
}
</script>
